<div
  class="tab-header d-flex flex-column flex-md-row justify-content-center justify-content-md-end align-items-sm-center align-items-start">
  <div class="count">
    <span [qcId]="'totalcount-span'" class="count-number text-black">{{ franchises?.totalCount }}</span>
    <span class="count-title">قيد امتياز</span>
  </div>
  <div class="filter d-flex justify-content-md-end">
    <div class="input-group search-group">
      <span class="input-group-text" [ngClass]="{ focused: filterInputFocus === true }" id="basic-addon1"><i
          class="fa-regular fa-magnifying-glass"></i></span>
      <input [qcId]="'search-btn'" type="text" #inputRef class="form-control" (focus)="onFocus()" (blur)="onBlur()"
        [(ngModel)]="searchText" (keyup.enter)="refreshFranchises(1)"
        placeholder="بحث برقم القيد أو الرقم الوطنى الموحد للمنشأة " />
    </div>

    <div ngbDropdown #dropdown="ngbDropdown" class="filter-critria">
      <button type="button" class="btn btn-outline-secondary search" id="dropdownConfig" ngbDropdownToggle>
        <i class="fa-solid fa-bars-filter"></i>
        <span>تصفية</span>
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownConfig">
        <app-filter (filterFormEvent)="filterData($event)"></app-filter>
      </div>
    </div>
  </div>
</div>
<div class="table-responsive">
  <table class="table table-hover">
    <thead>
      <tr>
        <th scope="col">رقم القيد</th>
        <th scope="col">سجل المانح</th>
        <th scope="col">سجل صاحب الامتياز</th>
        <th scope="col">نوع الامتياز</th>
        <th scope="col">الية المنح</th>
        <th scope="col">تاريخ بداية الامتياز</th>
        <th scope="col">تاريخ نهاية الامتياز</th>
        <!-- *ngIf="showStatus" -->
        <th scope="col">حالة القيد</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let franchise of franchises.franchiseModel">
        <td class="restriction-number">
          <a [routerLink]="['../Franchise', franchise.franchiseNumber]">#{{ franchise.franchiseNumber }}</a>
        </td>
        <td class="record" *ngIf="isInternal">
          <p class="record-name">{{ franchise.donorRecord.recordName }}</p>
          <span class="record-number text-grey">
            الرقم الوطنى الموحد للمنشأة: {{ franchise.donorRecord.recordNumber }}</span>
        </td>
        <td class="record" *ngIf="!isInternal">
          <p class="record-name">{{ franchise.donorRecord.recordName }}</p>
          <span class="record-number text-grey">
            رقم السجل التجارى: {{ franchise.donorRecord.recordNumber }}</span>
        </td>
        <td class="record">
          <p class="record-name">
            {{ franchise.franchiseRecord.franchiseName }}
          </p>
          <span class="record-number text-grey">
            الرقم الوطنى الموحد للمنشأة: {{ franchise.franchiseRecord.franchiseNumber }}</span>
        </td>
        <td>{{ franchise.franchiseType }}</td>
        <td>{{ franchise.referenceType }}</td>
        <td>{{ franchise.franchiseStartdate }}</td>
        <td>{{ franchise.franchiseEnddate }}</td>
        <!-- *ngIf="showStatus" -->
        <td>
          <span class="badge" [class]=" franchise.franchiseStatusName">
            {{ franchise.franchiseStatus }}
          </span>
        </td>
        <td>
          <div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown">
            <button type="button" class="btn btn-default me-2" id="dropdownManual" ngbDropdownToggle>
              <i class="fa-solid fa-ellipsis"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownManual">
              <button ngbDropdownItem [routerLink]="['../Franchise', franchise.franchiseNumber]">
                <i class="fa-regular fa-eye"></i>
                <span>عرض التفاصيل</span>
              </button>
              <button ngbDropdownItem (click)="printFranchiseCertificate(franchise.franchiseNumber)">
                <i class="fa-regular fa-file-certificate"></i>
                <span>طباعة الشهادة</span>
              </button>
            </div>
          </div>
        </td>
      </tr>
      <tr *ngIf="franchises?.totalCount === 0">
        <td class="center-message" colspan="9">
          <p>لا توجد بيانات</p>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="tab-footer">
    <div class="d-flex justify-content-between p-2">
      <div class="show-results d-flex align-items-center">
        <span>اظهر </span>
        <select class="form-select form-control" [(ngModel)]="pageSize" (ngModelChange)="onPageSizechange()">
          <option [ngValue]="10">10</option>
          <option [ngValue]="20">20</option>
          <option [ngValue]="50">50</option>
          <option [ngValue]="100">100</option>
        </select>
        <span>نتائج</span>
      </div>
      <ngb-pagination [collectionSize]="franchises?.totalCount" [(page)]="franchises.pageNumber"
        [pageSize]="franchises.pageSize" [maxSize]="10" (pageChange)="refreshFranchises($event)" [rotate]="true"
        [boundaryLinks]="true">
      </ngb-pagination>
    </div>
  </div>
</div>